import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { monthlyProcessApi, MONTH_OPTIONS, YEAR_OPTIONS } from '../api/monthlyProcessApi';
import { appToast } from '../../../../components/AppToast';

export function useMonthlyProcessRun() {
  const navigate = useNavigate();
  const today = new Date();

  const [companyId, setCompanyId] = useState(0);
  const [branchId, setBranchId] = useState(0);
  const [deptId, setDeptId] = useState(0);
  const [month, setMonth] = useState(today.getMonth() + 1);
  const [year, setYear] = useState(today.getFullYear());
  const [isProcessing, setIsProcessing] = useState(false);

  // Dynamic dropdown options
  const [options, setOptions] = useState({
    companies: [{ value: 0, label: 'All Companies' }],
    branches: [{ value: 0, label: 'All Branches' }],
    departments: [{ value: 0, label: 'All Departments' }],
  });

  useEffect(() => {
    monthlyProcessApi.getFilterOptions().then((data) => {
      if (data) {
        setOptions({
          companies: data.companies || [{ value: 0, label: 'All Companies' }],
          branches: data.branches || [{ value: 0, label: 'All Branches' }],
          departments: data.departments || [{ value: 0, label: 'All Departments' }],
        });
      }
    }).catch(() => {});
  }, []);

  const handleProcess = async () => {
    if (!month || !year) {
      appToast.error('Please select a valid month and year.');
      return;
    }
    setIsProcessing(true);
    try {
      const result = await monthlyProcessApi.runProcess({
        month,
        year,
        companyId: companyId || 0,
        branchId: branchId || 0,
        deptId: deptId || 0,
      });
      const monthName = MONTH_OPTIONS.find((m) => m.value === month)?.label || month;
      appToast.success(
        result.message || `Monthly attendance for ${monthName} ${year} processed successfully!`
      );
      navigate('/payroll/monthly-process');
    } catch (err) {
      const msg =
        err?.response?.data?.detail?.message ||
        (typeof err?.response?.data?.detail === 'string' ? err?.response?.data?.detail : null) ||
        err?.message ||
        'Failed to process monthly attendance.';
      appToast.error(msg);
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    state: {
      companyId,
      branchId,
      deptId,
      month,
      year,
      isProcessing,
      companyOptions: options.companies,
      branchOptions: options.branches,
      departmentOptions: options.departments,
      monthOptions: MONTH_OPTIONS,
      yearOptions: YEAR_OPTIONS,
    },
    actions: {
      setCompanyId,
      setBranchId,
      setDeptId,
      setMonth,
      setYear,
      handleProcess,
    },
  };
}
